let brandingCache = null;

export async function loadBranding() {
    if (brandingCache) return brandingCache;
    try {
        const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/branding`);
        brandingCache = await resp.json();
    } catch {
        brandingCache = {
            product_name: 'SecureOps Monitor',
            company_name: 'AMR',
            logo_url: '/logo.png',
            primary_color: '#5EE1D9',
            accent_color: '#1A1A2E',
            support_email: 'support@company.com',
        };
    }
    // Apply CSS custom properties
    document.documentElement.style.setProperty('--primary', brandingCache.primary_color);
    document.documentElement.style.setProperty('--accent', brandingCache.accent_color);
    document.title = brandingCache.product_name;
    return brandingCache;
}

export function getBranding() {
    return brandingCache;
}
